<template>
  <van-tabbar 
    v-model="tabbarIndex"
	  safe-area-inset-bottom
	  :border="false"
    active-color="var(--color-active)"
    z-index="2000"
  >
	  <van-tabbar-item to="/" name="home">
      <img slot="icon" slot-scope="props" :src="`./static/icon/${Theme}/${props.active?'icon-bar-home':'icon-bar-home-o'}.png`">
	    <span v-html="$t('footer[0]')"></span>
	  </van-tabbar-item>
	  <van-tabbar-item to="/video" name="video">
      <img slot="icon" slot-scope="props" :src="`./static/icon/${Theme}/${props.active?'icon-bar-video':'icon-bar-video-o'}.png`" />
      <span v-html="$t('footer[1]')"></span>
    </van-tabbar-item>
    <van-tabbar-item v-if="InitData.setting.is_crowdfunding==1" to="/partner" name="partner">
      <img slot="icon" slot-scope="props" :src="`./static/icon/${Theme}/${props.active?'icon-bar-partner':'icon-bar-partner-o'}.png`" />
      <span v-html="$t('footer[6]')"></span>
    </van-tabbar-item>
    <van-tabbar-item v-if="InitData.setting.is_activity==1" to="/activity" name="activity">
      <img slot="icon" slot-scope="props" :src="`./static/icon/${Theme}/${props.active?'icon-bar-community':'icon-bar-community-o'}.png`" />
      <van-icon slot="icon" slot-scope="props" :name="props.active?'point-gift':'point-gift-o'" />
      <span v-html="$t('footer[8]')"></span>
    </van-tabbar-item>
    <van-tabbar-item v-if="InitData.setting.is_community==1" to="/community" name="community">
      <img slot="icon" slot-scope="props" :src="`./static/icon/${Theme}/${props.active?'icon-bar-community':'icon-bar-community-o'}.png`" />
      <span v-html="$t('footer[7]')"></span>
    </van-tabbar-item>
	  <!-- <van-tabbar-item to="/serviceCenter" name="service">
      <img slot="icon" slot-scope="props" :src="`./static/icon/${Theme}/${props.active?'icon-bar-service':'icon-bar-service-o'}.png`" />
      <span v-html="$t('footer[3]')"></span>
	  </van-tabbar-item> -->
    <!-- <van-tabbar-item v-if="InitData.zonebannerList.length" to="/profit" name="profit">
      <img slot="icon" slot-scope="props" :src="`./static/icon/${Theme}/${props.active?'icon-bar-income':'icon-bar-income-o'}.png`" />
      <span v-html="$t('footer[5]')"></span>
    </van-tabbar-item> -->
    <van-tabbar-item to="/user" name="user">
      <img slot="icon" slot-scope="props" :src="`./static/icon/${Theme}/${props.active?'icon-bar-my':'icon-bar-my-o'}.png`" />
      <span v-html="$t('footer[4]')"></span>
    </van-tabbar-item>
	</van-tabbar>
</template>

<script>
export default {
  name: 'Footer',
  components: {
    
  },
  props: [],
  data() {
    return {
      tabbarIndex: this.$route.matched[0].meta.active,
    }
  },
  computed: {
  	
  },
  watch: {

  },
  created() {

  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    
  }
}
</script>
<style scoped>
.van-tabbar{
  box-shadow: 0 -1px 10px rgba(0, 0, 0, .1);
}
.van-tabbar>>>.van-tabbar-item__text{
  font-weight: 600;
  text-align: center;
}
</style>